function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import ListPolizaPayment from "./ListPolizaPayment";
import { ReactiveBase, ReactiveList, DataSearch, MultiDropdownList, DateRange, SelectedFilters } from "@appbaseio/reactivesearch";
import MomentLocaleUtils, { formatDate, parseDate } from "react-day-picker/moment";
import "moment/locale/es";
import { componentIds } from "./utils";
import "../../helperComponents/Elasticsearch/elasticsearch.scss";

var defaultQuery = function defaultQuery() {
  return {
    timeout: "10s",
    query: {
      match_all: {}
    },
    size: 1
  };
};

var IndexPolizaPayment = function IndexPolizaPayment(props) {
  var downloadReportUrl = props.downloadReportUrl,
      newPaymentPath = props.newPaymentPath,
      _props$downloadReport = props.downloadReportLabel,
      downloadReportLabel = _props$downloadReport === void 0 ? "Descargar Reporte" : _props$downloadReport,
      _props$newPaymentLabe = props.newPaymentLabel,
      newPaymentLabel = _props$newPaymentLabe === void 0 ? "Nuevo" : _props$newPaymentLabe,
      _props$panelTitle = props.panelTitle,
      panelTitle = _props$panelTitle === void 0 ? "Pago de pólizas" : _props$panelTitle;

  var _React$useState = React.useState("overdue_days"),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      sortField = _React$useState2[0],
      setSortField = _React$useState2[1];

  var _React$useState3 = React.useState("desc"),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      sortOrder = _React$useState4[0],
      setSortOrder = _React$useState4[1];

  var scrollPositionRef = React.useRef(0);

  var handleSort = function handleSort(field) {
    scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop || window.scrollY;

    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("desc");
    }
  };

  React.useEffect(function () {
    if (scrollPositionRef.current > 0) {
      var restoreScroll = function restoreScroll() {
        return window.scrollTo({
          top: scrollPositionRef.current,
          behavior: "auto"
        });
      };

      restoreScroll();
      requestAnimationFrame(function () {
        restoreScroll();
        setTimeout(restoreScroll, 50);
      });
    }
  }, [sortField, sortOrder]);

  var renderList = function renderList() {
    return /*#__PURE__*/React.createElement(ReactiveList, {
      componentId: "PolizaPaymentsList",
      dataField: sortField,
      pagination: true,
      size: 50,
      loader: "Cargando resultados...",
      sortBy: sortOrder,
      showResultStats: true,
      react: {
        and: componentIds()
      },
      render: function render(_ref) {
        var data = _ref.data;
        return /*#__PURE__*/React.createElement(ReactiveList.ResultListWrapper, {
          style: {
            overflow: "auto"
          }
        }, /*#__PURE__*/React.createElement(ListPolizaPayment, {
          payments: data,
          sortField: sortField,
          sortOrder: sortOrder,
          onSort: handleSort
        }));
      }
    });
  };

  var renderOptions = function renderOptions() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DataSearch, {
      className: "col-md-4 elasticsearch-component",
      componentId: "payment_search",
      dataField: ["id_keyword", "poliza.code", "poliza.contratante.full_name", "poliza.contratante.rut", "poliza.asegurado.full_name", "poliza.asegurado.rut"],
      queryFormat: "and",
      fuzziness: 2,
      title: "N\xBA propuesta, p\xF3liza, cuota o datos de contratante/asegurado",
      placeholder: "Buscar por n\xFAmero de propuesta, c\xF3digo de p\xF3liza, n\xFAmero de cuota, RUT o nombre",
      autosuggest: false,
      react: {
        and: componentIds("payment_search")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "payment_type",
      dataField: "payment_type_name.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showFilter: true,
      filterLabel: "Forma de pago",
      title: "Forma de pago",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("payment_type")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_ramo",
      dataField: "poliza.ramo.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showFilter: true,
      filterLabel: "Ramo",
      title: "Ramo",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("poliza_ramo")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_company",
      dataField: "poliza.company.name.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Compa\xF1\xEDa",
      title: "Compa\xF1\xEDa",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("poliza_company")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_contratante",
      dataField: "poliza.contratante.full_name.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Contratante",
      title: "Contratante",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("poliza_contratante")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_asegurado",
      dataField: "poliza.asegurado.full_name.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Asegurado",
      title: "Asegurado",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("poliza_asegurado")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_status",
      dataField: "poliza.status_name.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showFilter: true,
      filterLabel: "Estado de la p\xF3liza",
      title: "Estado de la p\xF3liza",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("poliza_status")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "overdue_status",
      dataField: "overdue_status.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showFilter: true,
      filterLabel: "Estado de cuota",
      title: "Estado de cuota",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("overdue_status")
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 elasticsearch-component"
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DateRange, {
      className: "col-md-4 elasticsearch-component",
      componentId: "due_date",
      dataField: "due_date",
      title: "Fecha de vencimiento",
      numberOfMonths: 2,
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Vencimiento",
      queryFormat: "date",
      placeholder: {
        start: "Inicio",
        end: "Término"
      },
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds("due_date")
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      className: "col-md-4 elasticsearch-component",
      componentId: "created_at",
      dataField: "created_at",
      title: "Creaci\xF3n",
      numberOfMonths: 2,
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Creaci\xF3n",
      queryFormat: "date",
      placeholder: {
        start: "Inicio",
        end: "Término"
      },
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds("created_at")
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      className: "col-md-4 elasticsearch-component",
      componentId: "updated_at",
      dataField: "updated_at",
      title: "\xDAltima actualizaci\xF3n",
      numberOfMonths: 2,
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Actualizaci\xF3n",
      queryFormat: "date",
      placeholder: {
        start: "Inicio",
        end: "Término"
      },
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds("updated_at")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DateRange, {
      className: "col-md-4 elasticsearch-component",
      componentId: "reminder_sent_at",
      dataField: "reminder_sent_at",
      title: "Env\xEDo",
      numberOfMonths: 2,
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Env\xEDo",
      queryFormat: "date",
      placeholder: {
        start: "Inicio",
        end: "Término"
      },
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds("reminder_sent_at")
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 elasticsearch-component"
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 elasticsearch-component"
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(SelectedFilters, {
      className: "elasticsearch-component",
      showClearAll: true,
      clearAllLabel: "Limpiar filtros"
    })));
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReactiveBase, {
    app: "poliza_payments",
    url: "".concat(process.env.SEGUROS_API_URL),
    headers: {}
  }, /*#__PURE__*/React.createElement("aside", null, renderOptions()), /*#__PURE__*/React.createElement("hr", {
    style: {
      margin: "20px 0"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "panel panel-default"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel-heading"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "panel-title"
  }, panelTitle), /*#__PURE__*/React.createElement("br", null), downloadReportUrl && /*#__PURE__*/React.createElement("a", {
    href: downloadReportUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "btn btn-primary"
  }, downloadReportLabel), newPaymentPath && /*#__PURE__*/React.createElement("a", {
    href: newPaymentPath,
    className: "btn btn-primary",
    style: {
      marginLeft: "8px"
    }
  }, newPaymentLabel)), /*#__PURE__*/React.createElement("div", {
    className: "panel-body"
  }, renderList()))));
};

export default IndexPolizaPayment;